module.exports = __webpack_public_path__ + "img/speedometer2.3399f6ae.svg";